module.exports = __webpack_public_path__ + "img/1450082395.478ea8d9.jpg";